import { CardTypesEnum, HealthPlanStatuses } from '@common-fe/common-fe';

import { IProcessingRuleDtoProcessingRuleTypeEnum } from '@/dtos/models/IProcessingRuleDto';
import { IServiceConfigDtoPaymentTypeEnum } from '@/dtos/models/IServiceConfigDto';
import { ITriggerDto, ITriggerDtoTriggerCategoryTypeEnum } from '@/dtos/models/ITriggerDto';

export type ProcessingRuleTypeEnum = IProcessingRuleDtoProcessingRuleTypeEnum;
export const ProcessingRuleType = IProcessingRuleDtoProcessingRuleTypeEnum;

export type ServicePaymentTypeEnum = IServiceConfigDtoPaymentTypeEnum;
export const ServicePaymentType = IServiceConfigDtoPaymentTypeEnum;

export type Trigger = ITriggerDto;

export type TriggerCategoryType = ITriggerDtoTriggerCategoryTypeEnum;
export const TriggerCategory = ITriggerDtoTriggerCategoryTypeEnum;
import { IHealthPlanDeductibleTriggerConfigDto } from '@/dtos/models/IHealthPlanDeductibleTriggerConfigDto';

export enum HealthPlanFieldState {
  Locked = 'LOCKED',
  Hidden = 'HIDDEN',
  Modifiable = 'MODIFIABLE',
  RequiredAtPlan = 'REQUIRED_AT_PLAN',
  RequiredAtAllLevels = 'REQUIRED_AT_ALL_LEVELS',
  NA = 'NA',
}

export enum HealthPlansType {
  Plan = 'Plan',
  Template = 'Template',
}

export interface HealthPlanListItemResponse {
  id: string;
  name: {
    name: string;
    name_state?: string;
  };

  health_plan_types: {
    health_plan_types: string[];
    health_plan_type_state: string;
  };
  deductibles_by_service_type: {
    deductibles_by_service_type: string;
    deductibles_by_service_type_state: string;
  };
  plan_status: string;
  plan_year?: {
    id: string;
    name: string;
  };
}

export interface PlanByPlanYearDto {
  id: string;
  name: string;
  max_election_amount: number | null;
  min_election_amount: number | null;
  per_person_spend_limit_amount: number | null;
  can_set_health_plan_spend_limits: boolean;
}

export interface PlanByPlanYear {
  id: string;
  name: string;
  maxElectionAmount: number;
  minElectionAmount: number;
  canSetHealthPlanSpendLimits: boolean;
}

export type HealthPlan = {
  id: string;
  name?: string;
  typeState: HealthPlanFieldState;
  types: CardTypesEnum[];
  status: HealthPlanStatuses;
  process?: { total: number; passed: number };
  info?: Partial<HealthPlansType>;
};

export interface AccountFundingConfig {
  id?: number;
  plan_id?: number;
  plan_name?: string;
  auto_enrollment_amount?: number;
  per_person_spend_limit_amount?: number;
  min_election_amount?: number;
  max_election_amount?: number;
}

export interface Plans {
  id: number;
  name: string;
}

export interface CategorySpendLimitConfig {
  id?: number;
  plan_id?: number;
  health_plan_id?: number;
  coverage_id?: number;
  category_type: string;
  category_spend_limit: number;
}

export interface HealthPlanDeductibleConfig {
  id?: number;
  created_at?: string;
  parent_id?: number;
  coverage?: {
    id?: number;
    name?: string;
    is_default?: boolean;
  };
  code?: {
    code?: string;
    code_state?: HealthPlanFieldState;
  };
  trigger_configs?: IHealthPlanDeductibleTriggerConfigDto[];
  auto_enroll_account_funding_configs?: AccountFundingConfig[];
}

export interface HealthPlanResponse {
  id: number | string;
  is_plan: boolean;
  are_plans_editable: boolean;
  summary?: string;
  parent_id: number;
  notes?: string;
  plan_year: Partial<{
    id: number;
    name: string;
    valid_from: string;
    valid_to: string;
    prior_plan_year_id: number;
  }>;
  plan_status: HealthPlanStatuses;
  plan_code: string;
  plan_year_id: number;
  name: Partial<{
    name: string;
    name_state: HealthPlanFieldState;
  }>;
  health_plan_types: Partial<{
    health_plan_types: string[];
    health_plan_type_state: HealthPlanFieldState;
  }>;
  deductibles_by_service_type: Partial<{
    deductibles_by_service_type: string;
    deductibles_by_service_type_state: HealthPlanFieldState;
  }>;
  carrier_id: Partial<{
    carrier_id: string;
    carrier_id_state: HealthPlanFieldState;
  }>;
  is_auto_enrollment: Partial<{
    is_auto_enrollment: boolean;
    is_auto_enrollment_state: HealthPlanFieldState;
  }>;
  per_person_spend_limit: boolean;
  per_category_spend_limit: boolean;
  category_spend_limits?: CategorySpendLimitConfig[];
  health_plan_deductible_configs: HealthPlanDeductibleConfig[];
  enrollment_matrix: Partial<{
    id: number;
    name: string | null;
    processing_rule_id: number;
  }>;
  plans: Plans[];
}
